// extracted by mini-css-extract-plugin
export default {"dropdownIcon":"_2Y27Y","rotated":"_2j3gf"};